const ENTITY_TYPE = 'person';

export {
  ENTITY_TYPE
}